/* cs-p02-product.js
 * P-02 產品頁腳本（sections/cs-p02-main-product.liquid 載入）。
 * 1. O1 大類卡（snippets/cs-p02-o1.liquid 只印卡片和資料屬性，行為在這裡）。
 *    先判斷「原本的款式選擇器是哪一種」，寫在 o1 的 data-mode，四種：
 *      cards  Codex 款式卡（[data-cs-v2-card-radio] radio，或 [data-cs-stage1-thumb] 縮圖）存在：
 *             規則 A：大類卡放在 Codex 卡上方；點大類卡只顯示屬於該類的款式卡，並點第一張有貨的（Codex 原本的換款流程接手）。
 *             規則 B1：Codex 卡本身已經是列表，O1 隱藏不重複。規則 B2：Codex 卡第 9 張起收起，加「顯示全部 N 個」。
 *      axis   Codex stage1 的下拉（variant-selects[data-cs-stage1-picker] 裡的 select[data-cs-stage1-axis]，例如 Kaleido、Niche Zero）：
 *             大類卡取代該軸的下拉（下拉隱藏但留在 DOM）；點卡＝把該軸 select 設成卡的值、送 bubbles 的 change，
 *             stage1 自己的 capture 監聽會補齊其餘軸（它依 data-cs-stage1-tuples 挑一組真的存在的組合）。
 *      native 主題原本的下拉、按鈕或色塊：大類卡取代該選項的控制（原本的只隱藏）。
 *             點卡＝先在 O1 伺服器印的變體表（data-cs-p02-o1-variants）裡挑「該類第一個有貨的款」，
 *             再把所有原本控制都同步成那個款的選項組合（不會留下不存在的組合），最後送一次 change 給主題的 variant-selects。
 *      link   以上都接不上：O1 照樣顯示，每張卡換成連到該類第一個有貨款的連結（?variant=…&view=p02），並在 O1 裡印 MISS 註解。
 *    🔴 任何分支都不會因為「找不到 radio」就把 O1 整組隱藏。唯一會隱藏的是規則 B1／B2 遇到 Codex 卡列表（它自己就是列表，這是有找到、不是沒找到）。
 *    沒有 JS：O1 保持隱藏（規則 A 由內嵌 style 的 .cs-p02-pdp:not(.cs-p02-o1-ready) 隱藏，B1／B2 帶 hidden），原本的選擇器照常可用。
 *    規則 A 有 Codex 款式卡（cards）或 stage1 下拉（axis）時，伺服器已先顯示 O1、先藏起預設大類以外的款式卡（或該軸下拉）；
 *    第一次 sync 套完後加 cs-p02-o1-ready 把那段 style 收掉（markReady）。
 *  - 選中的卡跟著「目前的款」走：讀 product form 的 input[name=id]、網址的 ?variant=，都不對就用伺服器印的預設款。
 *  - 主題換款時會把 variant-selects 整段換成伺服器新版本，所以隱藏與篩選要重做：input[name=id] 的 change 事件、popstate、
 *    以及 MutationObserver（只看「新增的元素節點」，而且不看 O1 自己與我們自己加的按鈕，避免自己改自己又觸發自己）。
 *  - 網址：預覽期用 ?view=p02 進來的頁面，換款後主題的 replaceState 會把 view 洗掉，這裡補回去（只在進來時網址有 view=p02 才補；
 *    範本正式指派給商品之後進來的頁面沒有 view 參數，就完全不動網址）。
 * 2. 商品描述在瀏覽器端切段（splitDescription）：伺服器把 product.description 原樣整段印進「產品介紹」列，
 *    這裡讀已解析的 DOM，依 h5 小標題把規格段、保養段的節點搬到另外兩列，沒搬走的留在原處。
 *    2026-10-17：導言（intro）段落改搬進規格列之前的「商品介紹」區（不可收合）；沒有內容就整區移除，JS 沒跑時該區 hidden、描述全文仍在規格列。
 * 3. 收合列「評價」的錨點：捲到頁面下方的 Judge.me 評價區。
 * （第十四輪：常一起用的「再看 N 件」改成原生 <details>，不再靠本檔；點擊處理已移除。）
 */
(function () {
  'use strict';
  if (window.__csP02Product) { return; }
  window.__csP02Product = true;

  var COLLAPSE_AT = 8;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function ids(card) { return (card.getAttribute('data-variant-ids') || '').split(',').filter(Boolean); }
  function setText(el, text) { if (el.textContent !== text) { el.textContent = text; } }
  function setAttr(el, name, val) { if (el.getAttribute(name) !== val) { el.setAttribute(name, val); } }
  function warnOnce(o1, msg) {
    if (o1._csWarned === msg) { return; }
    o1._csWarned = msg;
    if (window.console) { console.warn('cs-p02 o1: ' + msg); }
  }

  /* ---------- 網址保留 view=p02（預覽期方便；範本正式指派後進來的頁面沒有 view 參數，這段就不會動作） ---------- */
  var VIEW_P02 = false;
  try { VIEW_P02 = new URL(window.location.href).searchParams.get('view') === 'p02'; } catch (e) { /* 舊瀏覽器：略過 */ }
  function keepView() {
    if (!VIEW_P02 || !window.history || !window.history.replaceState) { return; }
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('view') === 'p02') { return; }
      u.searchParams.set('view', 'p02');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* 略過 */ }
  }

  function currentVariantId(o1) {
    var form = document.getElementById(o1.getAttribute('data-form') || '');
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) { return String(input.value); }
    try {
      var v = new URL(window.location.href).searchParams.get('variant');
      if (v) { return String(v); }
    } catch (e) { /* 舊瀏覽器沒有 URL：略過 */ }
    return o1.getAttribute('data-current-variant') || '';
  }

  function variantTable(o1) {
    if (o1._csVariants) { return o1._csVariants; }
    var el = q('[data-cs-p02-o1-variants]', o1);
    var list = [];
    try { list = JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { list = []; }
    o1._csVariants = list;
    return list;
  }

  function pickerInfo(o1) {
    var info = o1.closest('product-info') || document;
    var primary = q('variant-selects[data-primary]', info);
    var idx = parseInt(o1.getAttribute('data-opt-index'), 10);
    var radios = qa('[data-cs-v2-card-radio]', info);
    var thumbs = qa('[data-cs-stage1-thumb]', info);
    var axisSel = primary ? q('select[data-cs-stage1-axis="' + idx + '"]', primary) : null;
    return { info: info, primary: primary, radios: radios, thumbs: thumbs, axisSel: axisSel, idx: idx };
  }

  function cardWrapper(radio) {
    return radio.closest('.cs-hario-batch-picker__option') || radio.parentElement;
  }

  function radioAvailable(radio) {
    var w = cardWrapper(radio);
    if (w && w.querySelector('[data-cs-selection-available="true"]')) { return true; }
    if (w && w.querySelector('[data-cs-selection-available]')) { return false; }
    return !radio.disabled;
  }

  /* 第七輪（審查 S-B1）：A 規則頁的款式區小標跟著大類變，例如「款式（耐熱玻璃 3 款）」。
     Codex 款式卡的固定小標（legend「選擇款式」）不改 Codex 檔，用 CSS 視覺隱藏（仍留在 DOM 給讀屏器），
     我們自己的小標插在 variant-selects 前面（variant-selects 會被主題整段換掉，小標放外面才留得住）。 */
  function updateSub(o1, p, card) {
    if (!p.primary || !card || !q('legend', p.primary)) { return; }
    var tpl = o1.getAttribute('data-t-sub') || '';
    if (!tpl) { return; }
    var sub = o1._csSub;
    if (!sub) {
      sub = document.createElement('p');
      sub.className = 'cs-p02-o1-sub';
      sub.setAttribute('data-cs-p02-sub', '');
      o1._csSub = sub;
    }
    if (!sub.isConnected) { p.primary.insertAdjacentElement('beforebegin', sub); }
    setText(sub, tpl.replace('__V__', card.getAttribute('data-value') || '').replace('__N__', String(ids(card).length)));
    var pdp = o1.closest('.cs-p02-pdp');
    if (pdp && !pdp.classList.contains('cs-p02-sub-on')) { pdp.classList.add('cs-p02-sub-on'); }
  }

  function nativeControls(o1, p) {
    if (!p.primary) { return null; }
    var controls = qa('.product-form__input', p.primary);
    if (controls.length !== parseInt(o1.getAttribute('data-opt-count'), 10)) { return null; }
    return controls;
  }

  /* 目前是哪一種選擇器（回傳 mode 與判斷依據，依據會印在 data-mode-why） */
  function detectMode(o1, p) {
    if (p.radios.length || p.thumbs.length) {
      return { mode: 'cards', why: 'radios=' + p.radios.length + ' thumbs=' + p.thumbs.length };
    }
    if (p.axisSel) { return { mode: 'axis', why: 'stage1 axis select ' + p.idx }; }
    var controls = nativeControls(o1, p);
    if (controls && controls[p.idx]) {
      return { mode: 'native', why: 'controls=' + controls.length };
    }
    var reason = !p.primary ? 'no variant-selects[data-primary]' : 'controls do not match option count';
    return { mode: 'link', why: reason };
  }

  function setActive(o1, cur) {
    var cards = qa('[data-cs-p02-o1-card]', o1);
    var active = null;
    cards.forEach(function (c) {
      var on = ids(c).indexOf(cur) !== -1;
      if (c.tagName === 'A') { if (on) { setAttr(c, 'aria-current', 'true'); } else if (c.hasAttribute('aria-current')) { c.removeAttribute('aria-current'); } }
      else { setAttr(c, 'aria-pressed', on ? 'true' : 'false'); }
      if (on) { active = c; }
    });
    return active;
  }

  /* 規則 B2（O1 自己的卡）：第 8 個之後收起。文字沒變就不重寫（避免觸發 MutationObserver 迴圈） */
  function applyO1Collapse(o1, active) {
    var more = q('[data-cs-p02-o1-more]', o1);
    if (!more) { return; }
    var cards = qa('[data-cs-p02-o1-card]', o1);
    var total = cards.length;
    if (total <= COLLAPSE_AT) { if (!more.hidden) { more.hidden = true; } return; }
    if (active && cards.indexOf(active) >= COLLAPSE_AT) { o1.setAttribute('data-expanded', '1'); }
    var expanded = o1.getAttribute('data-expanded') === '1';
    cards.forEach(function (c, i) {
      var collapsed = i >= COLLAPSE_AT && !expanded;
      if (collapsed !== c.hasAttribute('data-collapsed')) {
        if (collapsed) { c.setAttribute('data-collapsed', ''); } else { c.removeAttribute('data-collapsed'); }
      }
    });
    if (more.hidden) { more.hidden = false; }
    setAttr(more, 'aria-expanded', expanded ? 'true' : 'false');
    setText(more, expanded
      ? (o1.getAttribute('data-t-less') || '')
      : (o1.getAttribute('data-t-all') || '').replace('__N__', String(total)));
  }

  /* 規則 B2（Codex 卡）：第 9 張起收起，按鈕放在 variant-selects 後面（variant-selects 會被主題整段換掉，按鈕放外面才留得住） */
  function applyCodexCollapse(o1, p) {
    var wrappers = p.radios.length ? p.radios.map(cardWrapper) : p.thumbs;
    var btn = o1._csMore;
    if (wrappers.length <= COLLAPSE_AT) {
      if (btn && !btn.hidden) { btn.hidden = true; }
      return;
    }
    var expanded = o1.getAttribute('data-codex-expanded') === '1';
    wrappers.forEach(function (w, i) { w.classList.toggle('cs-p02-cards-hidden', i >= COLLAPSE_AT && !expanded); });
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-p02-o1__more';
      btn.setAttribute('data-cs-p02-codex-more', '');
      o1._csMore = btn;
    }
    if (!btn.isConnected && p.primary) { p.primary.insertAdjacentElement('afterend', btn); }
    if (btn.hidden) { btn.hidden = false; }
    setAttr(btn, 'aria-expanded', expanded ? 'true' : 'false');
    setText(btn, expanded
      ? (o1.getAttribute('data-t-less') || '')
      : (o1.getAttribute('data-t-all') || '').replace('__N__', String(wrappers.length)));
  }

  /* 規則 A + Codex 卡：只留屬於目前大類的款式卡 */
  function applyCodexFilter(p, catIds) {
    p.radios.forEach(function (r) {
      var w = cardWrapper(r);
      if (w) { w.classList.toggle('cs-p02-cards-hidden', catIds.indexOf(r.getAttribute('data-cs-v2-variant-id')) === -1); }
    });
    p.thumbs.forEach(function (t) {
      t.classList.toggle('cs-p02-cards-hidden', catIds.indexOf(t.getAttribute('data-variant-id')) === -1);
    });
  }

  /* link 模式：把卡片換成連結（連到該類第一個有貨的款）。只做一次；MISS 註解寫進 O1 裡，看原始碼或 DOM 就找得到 */
  function toLinks(o1, why) {
    qa('[data-cs-p02-o1-card]', o1).forEach(function (c) {
      if (c.tagName === 'A') { return; }
      var href = c.getAttribute('data-href');
      if (!href) { return; }
      var a = document.createElement('a');
      Array.prototype.slice.call(c.attributes).forEach(function (at) {
        if (at.name === 'type' || at.name === 'aria-pressed') { return; }
        a.setAttribute(at.name, at.value);
      });
      a.setAttribute('href', href);
      a.innerHTML = c.innerHTML;
      if (c.getAttribute('aria-pressed') === 'true') { a.setAttribute('aria-current', 'true'); }
      c.parentNode.replaceChild(a, c);
    });
    if (!o1._csMiss) {
      o1._csMiss = true;
      o1.insertBefore(document.createComment(' cs-p02 o1 MISS: ' + why + ' - cards are links to the first in-stock variant '), o1.firstChild);
    }
    warnOnce(o1, 'cannot connect to the variant picker (' + why + '), showing links');
  }

  /* 第三十四輪 b（A1）：規則 A 的 O1 伺服器第一次印出來就是 JS 接手後的樣子（snippets/cs-p02-o1.liquid 內嵌 style：O1 先顯示、預設大類以外的 Codex 款式卡先藏）。
     那段 style 全部限定在 .cs-p02-pdp:not(.cs-p02-o1-ready)。這裡在「第一次 sync 把篩選、隱藏原控制都套完」的同一個同步區塊內加上 cs-p02-o1-ready，
     那段 style 就整段失效，之後的篩選完全由 cs-p02-cards-hidden 接手（客人換大類時預設大類以外的卡才不會一直被伺服器的 style 藏著）。
     中間沒有繪製：classList 加上去和前面的 class 切換在同一個 JS 工作裡，瀏覽器只會看到最後的狀態。 */
  function markReady(o1) {
    var pdp = o1.closest('.cs-p02-pdp');
    if (pdp && !pdp.classList.contains('cs-p02-o1-ready')) { pdp.classList.add('cs-p02-o1-ready'); }
  }

  function sync(o1) {
    var rule = o1.getAttribute('data-rule');
    var p = pickerInfo(o1);
    var cur = currentVariantId(o1);
    var d = detectMode(o1, p);
    setAttr(o1, 'data-mode', d.mode);
    setAttr(o1, 'data-mode-why', d.why);

    if (d.mode === 'cards') {
      if (rule === 'B1') { if (!o1.hidden) { o1.hidden = true; } return; }
      if (rule === 'B2') { if (!o1.hidden) { o1.hidden = true; } applyCodexCollapse(o1, p); return; }
      var itA = liveIntent(o1);
      var activeA = itA ? setActiveValue(o1, itA.value) : setActive(o1, cur);
      if (activeA) { applyCodexFilter(p, ids(activeA)); updateSub(o1, p, activeA); }
      markReady(o1);
      if (o1.hidden) { o1.hidden = false; }
      return;
    }

    if (d.mode === 'axis') {
      var ax = p.axisSel.closest('.product-form__input');
      if (ax && !ax.classList.contains('cs-p02-cat-hidden')) { ax.classList.add('cs-p02-cat-hidden'); }
    } else if (d.mode === 'native') {
      var controls = nativeControls(o1, p);
      if (!controls[p.idx].classList.contains('cs-p02-cat-hidden')) { controls[p.idx].classList.add('cs-p02-cat-hidden'); }
    } else {
      toLinks(o1, d.why);
    }
    var itN = liveIntent(o1);
    var active = itN ? setActiveValue(o1, itN.value) : setActive(o1, cur);
    if (rule === 'B2') { applyO1Collapse(o1, active); }
    markReady(o1);
    if (o1.hidden) { o1.hidden = false; }
  }

  function syncAll() {
    qa('[data-cs-p02-o1]').forEach(sync);
    keepView();
  }

  var raf = 0;
  function later() {
    if (raf) { return; }
    raf = window.requestAnimationFrame(function () { raf = 0; syncAll(); });
  }

  /* 該類第一個有貨的款（沒有有貨的就取該類第一個）。變體表是伺服器印的，o = 各選項值，a = 1 有貨 */
  function firstVariantOf(o1, value) {
    var idx = parseInt(o1.getAttribute('data-opt-index'), 10);
    var inCat = variantTable(o1).filter(function (v) { return v.o && v.o[idx] === value; });
    return inCat.filter(function (v) { return v.a === 1; })[0] || inCat[0] || null;
  }

  /* 原生控制：設成某個款的完整選項組合。
     主題的 variant-selects 讀值是 `select option[selected]`（屬性）與 `fieldset input:checked`，
     而 updateSelectionMetadata 只會更新「觸發 change 的那個 select」的 selected 屬性，
     所以其他 select 我們要自己把 selected 屬性搬過去；radio 設 checked 即可。最後只對大類那個控制送一次 change。 */
  function setNativeTuple(controls, options, idx) {
    // 先確認每個控制都有對應的值（缺任何一個就整個不動，避免只改到一半）
    var plan = [];
    for (var i = 0; i < controls.length; i++) {
      var want = options[i];
      var sel = controls[i].querySelector('select');
      if (sel) {
        var opt = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value === want; })[0];
        if (!opt) { return null; }
        plan.push({ sel: sel, opt: opt });
      } else {
        var radio = qa('input[type="radio"]', controls[i]).filter(function (r) { return r.value === want; })[0];
        if (!radio) { return null; }
        plan.push({ radio: radio });
      }
    }
    var trigger = null;
    plan.forEach(function (step, n) {
      if (step.sel) {
        Array.prototype.slice.call(step.sel.options).forEach(function (o) { o.removeAttribute('selected'); });
        step.opt.setAttribute('selected', 'selected');
        step.sel.value = step.opt.value;
        if (n === idx) { trigger = step.sel; }
      } else {
        if (step.radio.disabled) { step.radio.disabled = false; }
        step.radio.checked = true;
        if (n === idx) { trigger = step.radio; }
      }
    });
    return trigger;
  }

  /* 回傳 true＝已交給原本的控制；false＝接不上（呼叫端改走連結） */
  function nativeSelect(o1, p, value) {
    var controls = nativeControls(o1, p);
    if (!controls || !controls[p.idx]) { return false; }
    var target = firstVariantOf(o1, value);
    if (!target || !target.o || target.o.length !== controls.length) { return false; }
    var trigger = setNativeTuple(controls, target.o, p.idx);
    if (!trigger) { return false; }
    trigger.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* stage1 下拉：只設大類那一軸，stage1 的 capture 監聽會補齊其他軸；被它拒絕（值被還原）就回 false */
  function axisSelect(p, value, force) {
    var sel = p.axisSel;
    if (!sel) { return false; }
    var opt = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value === value; })[0];
    if (!opt) { return false; }
    if (sel.value === value && !force) { return true; }
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return sel.value === value;
  }

  function pressCard(o1, card) {
    qa('[data-cs-p02-o1-card]', o1).forEach(function (c) { setAttr(c, 'aria-pressed', c === card ? 'true' : 'false'); });
  }

  function goLink(o1, card, why) {
    var href = card.getAttribute('data-href');
    warnOnce(o1, 'click could not reach the picker (' + why + '), following the link');
    if (href) { window.location.href = href; }
  }

  /* ---------- 第二十三、二十四輪（提案，未套用）：P1 以「最後點的大類」為準＋P2 換款請求失敗／缺必要區塊時還原 ----------
     不包 fetch、不改原生檔。能觀察到的訊號：
       ① 原生在請求開始時（變更事件的 capture 階段早於原生的 bubble 監聽）→ 這裡先記下「上一個好的狀態」快照；
       ② 回應落地＝主表單 input[name=id] 收到非空的 change；回應缺資料＝原生把 id 清成空字串並 change（product-info.js:179、234-241）；
       ③ 斷線／HTTP 錯誤：PerformanceObserver 的 resource 條目 responseStatus 為 0 或 >=400（唯讀觀察，不改 fetch；Safari 舊版沒有 responseStatus，就靠 ④）；
       ④ 逾時：原生 fetch 沒有 timeout（product-info.js:124），這裡自己計時 INTENT_TTL（15 秒），到點就當失敗。
       ⑤ [r24] 回應落地後檢查必要區塊：原生的區塊更新是同步的，id 的 change 之後、setTimeout 0 之前就跑完。
          落地的那一刻重置 MutationObserver，setTimeout 0 時看 #price-／#Price-Alt- 這兩個容器有沒有被寫過（原生是 innerHTML 賦值，
          內容相同也會有 childList 紀錄，所以同價的款不會被誤判）；沒被寫過＝回應缺那個區塊（原生對缺的來源是靜默跳過，product-info.js:188-195）→ 當失敗還原，原因 missing:<區塊>。
          加購鍵、庫存、SKU 不列為必要（見 product-build.md §22.8）。
       ⑥ [r24 v3] 還原的範圍：快照含 id／網址／選款控制／價錢類 hidden／價錢與固定列價錢的內容（v4）／加購鍵／目前亮的主圖（media-gallery 的 is-active 那張與清單順序）。
          主圖用原生公開的 media-gallery.setActiveMedia(id, prepend, false) 換回（不自己搬原生的 li）；原生已把那張 li 移除、或沒有 media-gallery 就做不到。
          還原不了的（pickup、分享網址、圖片順序／圖庫彈窗、庫存／SKU／體積價）在還原之後「逐項實際比對快照」，
          只把真的不一樣的列進 data-cs-p02-unrestored（逗號分隔），沒有就不留這個屬性。
     失敗時用快照把畫面還原成「上一款」（不發請求），並呼叫原生 product-info 的 abortController.abort()（公開欄位，非改檔），避免之後才到的回應與還原打架。 */
  var INTENT_TTL = 15000;
  var DOUBLE_TAP_MS = 600;
  var HIDE_IDS = ['price', 'Price-Alt', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules'];
  var pending = null;
  var restoredN = 0;
  var UNRESTORED_BLOCKS = [['Inventory', 'inventory'], ['Sku', 'sku'], ['Volume', 'volume-price'], ['Price-Per-Item', 'volume-price']];   // 還原不了的文字區塊：id → 記號用的名字
  var REQUIRED_BLOCKS = ['price', 'Price-Alt'];   // 顧客下單時看得到、原生每次換款都會寫的價錢容器
  var PICKER_KEYS = ['primary', 'sticky'];   // 原生 updateOptionValues 會整個換掉的兩個 variant-selects（product-info.js:161-170）

  /* [r29 甲1] 原生是插入新節點、把舊的 display:none、500ms 後才移除（global.js HTMLUpdateUtility.viewTransition），所以取「沒被藏起來」的那一個 */
  function livePicker(info, k) {
    return qa('variant-selects[data-' + k + ']', info).filter(function (el) { return el.style.display !== 'none'; })[0] || null;
  }
  /* [r29 乙5] 原生的請求網址帶 section_id=<sectionId>（product-info.js:152、450-452）；同頁別的 product-info（例如快速預覽）的請求不算主商品的 */
  function sameSection(name, p) {
    var m = /[?&]section_id=([^&#]+)/.exec(name);
    var sec = p.info.dataset.originalSection || p.info.dataset.section || '';
    try { return !!m && decodeURIComponent(m[1]) === sec; } catch (e) { return false; }
  }

  function liveIntent(o1) {
    var it = o1._csIntent;
    if (it && Date.now() - it.t > INTENT_TTL) { o1._csIntent = null; it = null; }
    return it || null;
  }
  function clearIntent(o1) { o1._csIntent = null; }

  function setActiveValue(o1, value) {
    var active = null;
    qa('[data-cs-p02-o1-card]', o1).forEach(function (c) {
      var on = c.getAttribute('data-value') === value;
      if (c.tagName === 'A') { if (on) { setAttr(c, 'aria-current', 'true'); } else if (c.hasAttribute('aria-current')) { c.removeAttribute('aria-current'); } }
      else { setAttr(c, 'aria-pressed', on ? 'true' : 'false'); }
      if (on) { active = c; }
    });
    return active;
  }

  /* [v3] 主圖狀態：原生 media-gallery 的 viewer（elements.viewer，找不到就用 [id^=GalleryViewer]）裡 is-active 的 li 與全部 li 的順序 */
  function galleryOf(info) { return q('media-gallery', info); }
  function viewerOf(gal) { return gal ? ((gal.elements && gal.elements.viewer) || q('[id^="GalleryViewer"]', gal)) : null; }
  function mediaState(info) {
    var gal = galleryOf(info), v = viewerOf(gal);
    if (!gal || !v) { return null; }
    var lis = qa('[data-media-id]', v);
    var act = q('[data-media-id].is-active', v);
    var order = lis.map(function (li) { return li.getAttribute('data-media-id'); });
    var activeId = act ? act.getAttribute('data-media-id') : null;
    return { activeId: activeId, order: order, first: !!activeId && order[0] === activeId };
  }

  function takeSnapshot(o1, info) {
    var sec = info.getAttribute('data-section') || '';
    var inputs = qa('form input[name="id"]', info).filter(function (i) { return i.form && /^product-form/.test(i.form.getAttribute('id') || ''); });
    var pf = q('product-form', info);
    var hidden = {};
    HIDE_IDS.forEach(function (k) { var el = document.getElementById(k + '-' + sec); if (el) { hidden[k] = el.classList.contains('hidden'); } });
    var sh = q('share-button input', info);
    var pk = q('pickup-availability', info);
    var mc = document.querySelector('#ProductModal-' + sec + ' .product-media-modal__content');
    var blocks = {};
    UNRESTORED_BLOCKS.forEach(function (b) { var el = document.getElementById(b[0] + '-' + sec); if (el) { blocks[b[0]] = el.innerHTML; } });
    var priceHtml = {};
    REQUIRED_BLOCKS.forEach(function (b) { var el = document.getElementById(b + '-' + sec); if (el) { priceHtml[b] = el.innerHTML; } });
    // [r29 甲1] 選款區整段（Stage1 已選款式卡、選項的 disabled／hidden、[data-selected-variant] JSON 都在裡面）與固定列的已選摘要
    var pickers = PICKER_KEYS.map(function (k) { var el = livePicker(info, k); return el ? { k: k, html: el.innerHTML } : null; }).filter(Boolean);
    // 摘要只取主商品這個 section 裡的（同頁別的商品若也有摘要，不跟著還原）
    var summaries = qa('[data-cs-selected-options]', document.getElementById('shopify-section-' + sec) || info).map(function (el) { return { el: el, text: el.textContent }; });
    return {
      pickers: pickers,
      summaries: summaries,
      priceHtml: priceHtml,
      share: sh ? sh.value : null,
      pickup: pk ? pk.innerHTML : null,
      pickupAvail: pk ? pk.hasAttribute('available') : null,
      media: mediaState(info),
      modalFirst: mc ? mc.firstElementChild : null,
      blocks: blocks,
      id: currentVariantId(o1),
      inputs: inputs.map(function (i) { return { el: i, value: i.value }; }),
      url: window.location.pathname + window.location.search + window.location.hash,
      btnDisabled: !!(pf && pf.submitButton && pf.submitButton.hasAttribute('disabled')),
      btnText: pf && pf.submitButtonText ? pf.submitButtonText.textContent : null,
      hidden: hidden,
      sec: sec
    };
  }

  function clearPending() {
    if (!pending) { return; }
    window.clearTimeout(pending.timer);
    if (pending.mo) { try { pending.mo.disconnect(); } catch (e) { /* 略 */ } }
    pending.o1.removeAttribute('data-cs-p02-intent');
    pending = null;
  }

  function armTimer(p) {
    window.clearTimeout(p.timer);
    p.timer = window.setTimeout(function () { if (pending === p) { failPending('timeout'); } }, INTENT_TTL);
  }

  /* 原生要開始一次換款（capture 階段，早於原生監聽）。同一輪連點時沿用第一次的快照（它才是「上一個好的狀態」） */
  function beginPending(info) {
    var o1 = q('[data-cs-p02-o1]', info);
    if (!o1) { return; }
    var ctrl0 = info.abortController;
    if (pending && pending.info === info) {
      pending.lastStart = window.performance.now();
      pending.landed = false;
      armTimer(pending);
    } else {
      pending = { info: info, o1: o1, t: Date.now(), lastStart: window.performance.now(), snap: takeSnapshot(o1, info), timer: 0, landed: false, hits: {}, watched: [], nodes: {}, mo: null };
      watchBlocks(pending);
      armTimer(pending);
    }
    var it = o1._csIntent;
    setAttr(o1, 'data-cs-p02-intent', it ? (it.index || it.value) : '-');
    // 變更被別的程式接手拒絕（例如款式卡的組合不完整）時，原生根本沒發請求：下一個 tick 看原生有沒有換新的 abortController
    var p0 = pending;
    if ('abortController' in info) {
      window.setTimeout(function () {
        if (pending === p0 && info.abortController === ctrl0 && !p0.sawRequest) { clearPending(); clearIntent(o1); }
        else { p0.sawRequest = true; }
      }, 0);
    }
  }

  /* [r24] 盯必要區塊的寫入：只盯頁面上真的有的容器（沒有的＝這個版型不顯示，不算缺） */
  function watchBlocks(p) {
    if (!window.MutationObserver) { return; }
    var sec = p.snap.sec;
    p.mo = new window.MutationObserver(function (ms) {
      if (!p.landed) { return; }
      ms.forEach(function (m) { var k = m.target.nodeType === 1 ? m.target : m.target.parentNode; REQUIRED_BLOCKS.forEach(function (b) { var el = document.getElementById(b + '-' + sec); if (el && k && el.contains(k)) { p.hits[b] = (p.hits[b] || 0) + 1; } }); });
    });
    REQUIRED_BLOCKS.forEach(function (b) {
      var el = document.getElementById(b + '-' + sec);
      if (el && p.info.contains(el)) { p.watched.push(b); p.nodes[b] = el; p.mo.observe(el, { childList: true, characterData: true, subtree: true }); }
    });
  }

  /* [r24] 落地：原生在 id 的 change「之後」才寫價錢等區塊（updateVariantInputs 在 updateSourceFromDestination 之前），
     所以這裡先清空觀察紀錄，等 setTimeout 0（原生的同步更新已跑完）再看哪些必要區塊沒被寫到 */
  function landPending(p) {
    window.clearTimeout(p.timer);
    p.landed = true; p.hits = {};
    if (p.mo) { p.mo.takeRecords(); }
    window.setTimeout(function () {
      if (pending !== p || !p.landed) { return; }
      // 觀察的那個節點被別的程式換掉了（id 還在、節點不是原本那個）＝我們看不到它的寫入，沒辦法判斷，不算缺（否則會每次都誤還原）
      var miss = p.watched.filter(function (b) { return !p.hits[b] && document.getElementById(b + '-' + p.snap.sec) === p.nodes[b] && p.nodes[b].isConnected; });
      if (miss.length) { failPending('missing:' + miss.join('+')); } else { clearPending(); clearIntent(p.o1); }
    }, 0);
  }

  function onIdChange(inp) {
    var p = pending;
    if (!p || !inp.form) { return; }
    if (inp.form.getAttribute('id') !== p.o1.getAttribute('data-form')) { return; }
    if (inp.value) { if (!p.landed) { landPending(p); } return; }   // 回應落地
    window.setTimeout(function () { if (pending === p) { failPending('no-id'); } }, 0);   // 原生清空了 id：等它把 setUnavailable 跑完再還原
  }

  function failPending(reason) {
    var p = pending;
    if (!p) { return; }
    clearPending();
    clearIntent(p.o1);
    try { if (p.info.abortController && typeof p.info.abortController.abort === 'function') { p.info.abortController.abort(); } } catch (e) { /* 略 */ }
    restoreSnapshot(p, reason);
  }

  /* 依「上一款」的選項組合把選款控制設回去（只設 value／selected／checked／aria-pressed，不送 change，不發請求） */
  function restoreControls(o1, info, id) {
    var v = variantTable(o1).filter(function (x) { return String(x.id) === String(id); })[0];
    var opts = v && v.o;
    qa('variant-selects', info).forEach(function (vs) {
      if (vs.hasAttribute('data-cs-stage1-current-variant-id')) { setAttr(vs, 'data-cs-stage1-current-variant-id', String(id)); }
      if (vs.hasAttribute('data-cs-v2-current-variant-id')) { setAttr(vs, 'data-cs-v2-current-variant-id', String(id)); }
      if (opts) {
        qa('select', vs).forEach(function (sel, i) {
          if (i >= opts.length) { return; }
          var opt = Array.prototype.slice.call(sel.options).filter(function (o) { return o.value === opts[i]; })[0];
          if (!opt) { return; }
          Array.prototype.forEach.call(sel.options, function (o) { o.removeAttribute('selected'); });
          opt.setAttribute('selected', 'selected');
          sel.value = opt.value;
        });
      }
      qa('[data-cs-v2-card-radio]', vs).forEach(function (r) { r.checked = r.getAttribute('data-cs-v2-variant-id') === String(id); });
      qa('[data-cs-stage1-thumb]', vs).forEach(function (t) { setAttr(t, 'aria-pressed', t.getAttribute('data-variant-id') === String(id) ? 'true' : 'false'); });
    });
    var p = pickerInfo(o1);
    if (opts && !p.radios.length && !p.thumbs.length && !p.axisSel) {
      var controls = nativeControls(o1, p);
      if (controls && controls.length === opts.length) { setNativeTuple(controls, opts, p.idx); }
    }
  }

  /* [v3] 主圖還原：只呼叫原生的 media-gallery.setActiveMedia(id, prepend, false)，不搬原生的 li。
     已經亮著快照那張就不呼叫（原生沒動過圖，例如 fetch-0、timeout）；快照那張 li 被原生移除了、沒有 media-gallery、方法不存在就做不到（交給 unrestoredItems 列出）。
     prepend 只在快照時它本來就排第一才用（原生換款後也是把新款主圖排第一），不然不動順序，避免和原生的排序打架。 */
  function restoreMedia(info, s) {
    var m = s.media;
    var gal = galleryOf(info), v = viewerOf(gal);
    if (!m || !m.activeId || !gal || !v || typeof gal.setActiveMedia !== 'function') { return; }
    var cur = q('[data-media-id].is-active', v);
    if (cur && cur.getAttribute('data-media-id') === m.activeId) { return; }
    var target = qa('[data-media-id]', v).filter(function (li) { return li.getAttribute('data-media-id') === m.activeId; })[0];
    if (!target) { return; }
    try { gal.setActiveMedia(m.activeId, m.first, false); } catch (e) { /* 部分完成也無妨，下面會實際比對 */ }
  }

  /* [v3] 還原之後實際沒回到快照的項目（固定順序）。pickup 的更新是非同步的，原生跑過（no-id、missing:*）就一律算沒還原 */
  function unrestoredItems(p, reason) {
    var s = p.snap, info = p.info, out = [];
    var sh = q('share-button input', info);
    if (s.share !== null && sh && sh.value !== s.share) { out.push('share-url'); }
    var pk = q('pickup-availability', info);
    if (pk && s.pickup !== null && (reason === 'no-id' || reason.indexOf('missing:') === 0 || pk.innerHTML !== s.pickup || pk.hasAttribute('available') !== s.pickupAvail)) { out.push('pickup'); }
    var m = s.media, now = mediaState(info);
    if (m && now) {
      if (m.activeId && now.activeId !== m.activeId) { out.push('media'); }
      if (now.order.join('|') !== m.order.join('|')) { out.push('media-order'); }
    }
    var mc = document.querySelector('#ProductModal-' + s.sec + ' .product-media-modal__content');
    if (mc && s.modalFirst && mc.firstElementChild !== s.modalFirst) { out.push('media-modal'); }
    UNRESTORED_BLOCKS.forEach(function (b) {
      var el = document.getElementById(b[0] + '-' + s.sec);
      if (el && (b[0] in s.blocks) && el.innerHTML !== s.blocks[b[0]] && out.indexOf(b[1]) === -1) { out.push(b[1]); }
    });
    // [r29 甲1] 選款區整段被換回後仍有一個不見了（原生正在換節點）＝沒還原；固定列摘要同理
    if (s.pickers.some(function (r) { return !livePicker(info, r.k); })) { out.push('picker'); }
    if (s.summaries.some(function (r) { return !r.el.isConnected || r.el.textContent !== r.text; })) { out.push('summary'); }
    return out;
  }

  function restoreSnapshot(p, reason) {
    var o1 = p.o1, info = p.info, s = p.snap;
    // ① 款式 id（主表單、分期表單、固定列表單）
    s.inputs.forEach(function (r) { if (r.el.isConnected) { r.el.value = r.value; } });
    // ② 網址（原生的 updateURL 在回應缺資料時把 ?variant= 拿掉了）
    try { if (window.history && window.history.replaceState && s.url) { window.history.replaceState(window.history.state, '', s.url); } } catch (e) { /* 略 */ }
    // ③ 選款控制：[r29 甲1] 先把原生換進來的選款區整段換回快照（不送 change），再依上一款設 value／checked
    s.pickers.forEach(function (r) {
      var el = livePicker(info, r.k);
      if (!el || el.innerHTML === r.html) { return; }
      var ae = document.activeElement, fid = ae && ae.id && el.contains(ae) ? ae.id : '';   // 鍵盤操作時焦點在選款控制上：換回後補回同一個 id
      el.innerHTML = r.html;
      if (fid) { var f = document.getElementById(fid); if (f && el.contains(f)) { try { f.focus({ preventScroll: true }); } catch (e) { /* 略 */ } } }
    });
    restoreControls(o1, info, s.id);
    // ④ 價錢等區塊的 hidden（原生 setUnavailable 加的）
    HIDE_IDS.forEach(function (k) { var el = document.getElementById(k + '-' + s.sec); if (el && k in s.hidden) { el.classList.toggle('hidden', !!s.hidden[k]); } });
    // ④b [v4] 價錢容器的內容：原生在回應缺「別的」價錢區塊時（例如缺 Price-Alt）已把這一個寫成新款的價錢，
    //      只還原 hidden 不夠（v3 量到 id 是舊款、價錢是新款）。內容不同才寫回快照
    REQUIRED_BLOCKS.forEach(function (k) { var el = document.getElementById(k + '-' + s.sec); if (el && (k in s.priceHtml) && el.innerHTML !== s.priceHtml[k]) { el.innerHTML = s.priceHtml[k]; } });
    // ⑤ 加購鍵
    var pf = q('product-form', info);
    if (pf && pf.submitButton) {
      if (s.btnDisabled) { pf.submitButton.setAttribute('disabled', 'disabled'); } else { pf.submitButton.removeAttribute('disabled'); }
      if (s.btnText !== null && pf.submitButtonText && pf.submitButtonText.textContent !== s.btnText) { pf.submitButtonText.textContent = s.btnText; }
    }
    // ⑤b [v3] 主圖：用原生公開的 setActiveMedia 換回快照那張
    restoreMedia(info, s);
    // ⑥ 通知同頁別的監聽者（固定加購列等）：主表單 id 的 change
    var main = s.inputs.filter(function (r) { return r.el.form && r.el.form.getAttribute('id') === o1.getAttribute('data-form'); })[0];
    if (main && main.el.isConnected) { main.el.dispatchEvent(new Event('change', { bubbles: true })); }
    // ⑥b [r29 甲1] 固定列的已選摘要只在原生 variantChange 時更新（cs-p02-wave1-pdp.js syncVariantState），這裡直接寫回快照的字
    s.summaries.forEach(function (r) { if (r.el.isConnected && r.el.textContent !== r.text) { r.el.textContent = r.text; } });
    // ⑦ 亮的卡、款式卡篩選
    sync(o1);
    // ⑧ 記號：原因、還原到哪個款、第幾次（只改這一個屬性，不洪水）
    restoredN++;
    o1.setAttribute('data-cs-p02-restored', reason + ':' + s.id + ':' + restoredN);
    // ⑨ [v3] 還原不了的東西：逐項實際比對快照，不一樣的才列
    var un = unrestoredItems(p, reason);
    if (un.length) { o1.setAttribute('data-cs-p02-unrestored', un.join(',')); }
    else if (o1.hasAttribute('data-cs-p02-unrestored')) { o1.removeAttribute('data-cs-p02-unrestored'); }
  }

  /* [P1] 早退只在「沒有在途意圖」且目前款就在被點的類別時才成立；
     有指向別類的意圖（請求在途、表單 id 還是舊的）時，點回原本的類別要照樣發請求。
     [P2] 同一張卡的第二下：600ms 內當連點忽略；之後（上一個請求還沒落地）強制重發。 */
  function selectCategory(o1, card) {
    var catIds = ids(card);
    var value = card.getAttribute('data-value');
    var cur = currentVariantId(o1);
    var it = liveIntent(o1);
    var force = false;
    if (it && it.value === value) {
      if (Date.now() - it.t < DOUBLE_TAP_MS) { return; }
      force = true;
    } else if (!it && catIds.indexOf(cur) !== -1) { later(); return; }
    o1._csIntent = { value: value, index: card.getAttribute('data-index') || '', t: Date.now() };
    dispatchCategory(o1, card, catIds, value, force);
    if (!pending) { clearIntent(o1); }   // 沒有任何請求被發出（被接手的控制拒絕等）就不留意圖
  }

  function dispatchCategory(o1, card, catIds, value, force) {
    var p = pickerInfo(o1);
    var d = detectMode(o1, p);

    if (d.mode === 'cards') {
      var target = null;
      if (p.radios.length) {
        var inCat = p.radios.filter(function (r) { return catIds.indexOf(r.getAttribute('data-cs-v2-variant-id')) !== -1; });
        target = inCat.filter(radioAvailable)[0] || inCat[0] || null;
      } else {
        var tin = p.thumbs.filter(function (t) { return catIds.indexOf(t.getAttribute('data-variant-id')) !== -1; });
        target = tin.filter(function (t) { return !t.disabled; })[0] || tin[0] || null;
      }
      if (!target) { goLink(o1, card, 'no card for this category'); return; }
      // 先讓大類卡跟著亮起、款式卡先篩好，再交給 Codex 的換款流程
      pressCard(o1, card);
      applyCodexFilter(p, catIds);
      updateSub(o1, p, card);
      if (force && target.checked) { target.checked = false; }   // 已選中的 radio 再 click 不會送 change，強制重發要先取消勾選
      target.click();
      return;
    }
    if (d.mode === 'axis') {
      if (axisSelect(p, value, force)) { pressCard(o1, card); return; }
      goLink(o1, card, 'stage1 axis rejected the value');
      return;
    }
    if (d.mode === 'native') {
      if (nativeSelect(o1, p, value)) { pressCard(o1, card); return; }
      goLink(o1, card, 'native controls could not be synced');
      return;
    }
    goLink(o1, card, d.why);
  }

  /* ---------- 商品描述切段（固定三列：規格／評價／保養；第七輪 M-A2；2026-10-17 前面多一區「商品介紹」） ----------
     伺服器把整段描述印在「規格」列的 [data-cs-p02-desc-src]。這裡讀已解析的 DOM：
     保養段搬進保養列；導言（摘要、產品介紹與選購…，kind === 'intro' 的 h5 段落）搬進規格列之前的商品介紹區 [data-cs-p02-intro-body]
     （第一個 h5 與區名重複，CSS 藏掉）；第一個 h5 之前的前言節點也搬進商品介紹區（排最前面）；完全沒有 h5 的描述整段搬進介紹區，規格列只留 facts；
     規格段留在規格列。含 ≥2 個 h5 的子節點會遞迴展開後切段；超過深度上限才回退。結構異常（展開失敗的巢狀多個 h5、host 底下找不到 h5）維持原樣：移除介紹區、描述全文留在規格列。
     小標同時含規格類字與保養類字時，段內找保養類子標題，那個節點起到段尾歸保養；找不到就整段留在規格。
     保固類小標（售後保養、原廠一年保養、行貨、warranty…）歸商品介紹，不進保養列（2026-10-22，見下方 WARRANTY_RE）。 */
  var SPEC_RE = /規格|資料|兼容|相容/;
  var CARE_RE = /使用|保養|清潔|沖煮|安全|疑難|首次|熱源|電源|注意|售後/;
  /* 2026-10-20（r40 F4）：外語小標。繁中那兩個正規式一個字都沒動，新字另開（簡體、日文、英文），用 headingHas 併進去。
     英文要「單字邊界」，所以英文那組比對的是「空白壓成一個空格」的小標（Use and cleaning），不是繁中用的「空白全拿掉」（Useandcleaning 會讓 \b 失效）。
     只吃小標文字，不看內文。 */
  var SPEC_RE_X = /规格|资料|兼容|仕様|互換/;
  var CARE_RE_X = /保养|清洁|冲煮|疑难|热源|电源|售后|手入れ|洗浄|注意|安全|使い方/;
  var SPEC_RE_EN = /\bspecs?\b|\bspecifications?\b|\bcompatib(?:le|ility)\b/i;
  var CARE_RE_EN = /\bcare\b|\bcleaning\b|\bmaintenance\b|\bsafety\b|\btroubleshooting\b|\bwarranty\b|\bfirst use\b|\bhow to use\b/i;
  /* 2026-10-22（r42 m251，架構師裁定甲）：保固類小標一律歸「商品介紹」，不進「清潔保養」列。
     店主 10-19 定：「清潔保養」格只放清潔方式（香港用語「保養」＝保固）；保固／送貨／安裝是買前資訊，放介紹。
     單獨的「保養」不算保固用詞：「使用與保養」「保養」是清潔，仍歸保養列；只有「售後、保固、保修、保養期、原廠…保養、一年保養、行貨、warranty」才算。
     繁中、簡體、英文三組分開（同 SPEC_RE／SPEC_RE_X／SPEC_RE_EN 的寫法）；CARE_RE 等既有正規式一個字都沒動。
     英文比對的是空白壓成一個空格的小標（同 CARE_RE_EN）。 */
  var WARRANTY_RE = /售後|保固|保修|保養期|原廠.{0,6}保養|一年保養|行貨/;
  var WARRANTY_RE_X = /售后|保修|保养期|原厂.{0,6}保养|一年保养|行货/;
  var WARRANTY_RE_EN = /\bwarranty\b/i;
  function headingHas(kind, text) {
    var raw = String(text || '');
    var t = raw.replace(/\s+/g, '');
    var s = raw.replace(/\s+/g, ' ').trim();
    if (kind === 'spec') { return SPEC_RE.test(t) || SPEC_RE_X.test(t) || SPEC_RE_EN.test(s); }
    return CARE_RE.test(t) || CARE_RE_X.test(t) || CARE_RE_EN.test(s);
  }
  function classifyHeading(text) {
    var t = String(text || '').replace(/\s+/g, '');
    var s = String(text || '').replace(/\s+/g, ' ').trim();
    if (WARRANTY_RE.test(t) || WARRANTY_RE_X.test(t) || WARRANTY_RE_EN.test(s)) { return 'intro'; }
    if (t.indexOf('結構') !== -1) { return 'intro'; }
    var sp = headingHas('spec', text);
    var ca = headingHas('care', text);
    if (sp && ca) { return 'mixed'; }
    if (sp) { return 'spec'; }
    if (ca) { return 'care'; }
    return 'intro';
  }

  /* 混合小標的段內：找第一個「保養類子標題」節點（h1 到 h4，或整段只有粗體字的 p），回傳它在 nodes 裡的位置，找不到回 -1 */
  function careMarkerIndex(nodes) {
    for (var i = 1; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType !== 1) { continue; }
      var tag = n.tagName;
      var isHead = /^H[1-4]$/.test(tag);
      if (!isHead && tag === 'P') {
        var strong = n.querySelector('strong, b');
        isHead = !!strong && (strong.textContent || '').replace(/\s+/g, '') === (n.textContent || '').replace(/\s+/g, '');
      }
      if (isHead && headingHas('care', n.textContent)) { return i; }
    }
    return -1;
  }

  function commonAncestor(nodes, stop) {
    var a = nodes[0].parentNode;
    while (a && a !== stop) {
      var all = true;
      for (var i = 1; i < nodes.length; i++) { if (!a.contains(nodes[i])) { all = false; break; } }
      if (all) { return a; }
      a = a.parentNode;
    }
    return stop;
  }

  /* 2026-10-17（Codex r35a #2／r35c／r35d）：「有沒有東西會被呈現」只有這一個標準 hasRenderable(node)，hasContent、isTrulyEmpty、isBlankNode 都用它，介紹／規格／保養三區同一把尺。
     為真的條件：
       - 文字節點去空白（含 &nbsp;）後非空；
       - 已標 .cs-p02-dup-h 的小標一律不算（它被藏了）；
       - 媒體（img、picture、video、iframe、embed、object、table、svg、audio、canvas）或 a[href]；
       - role="img"，或 inline style 含 background（不分大小寫）；
       - 算出來的 backgroundImage 存在且不是 none（搬移前記錄在 _csBg，見 computedBg）；
       - 未知標籤或自訂元素（標籤名含連字號）；
       - 其餘已知文字包裝元素（不管帶什麼 class、style、aria、data 屬性）：遞迴看子節點，任一子節點為真才算。
     寧可多留（未知一律算有），不讓內容消失；空的包裝（<p><br></p>、<p style="text-align:center"><br></p>）不算。 */
  function isDupMarked(n) { return !!n && n.nodeType === 1 && !!n.classList && n.classList.contains('cs-p02-dup-h'); }
  var RENDER_MEDIA = { IMG: 1, PICTURE: 1, VIDEO: 1, IFRAME: 1, EMBED: 1, OBJECT: 1, TABLE: 1, SVG: 1, AUDIO: 1, CANVAS: 1 };
  var RENDER_WRAPPERS = { P: 1, DIV: 1, SPAN: 1, SECTION: 1, ARTICLE: 1, STRONG: 1, B: 1, EM: 1, I: 1, U: 1, SMALL: 1, FONT: 1, MARK: 1, SUB: 1, SUP: 1, CENTER: 1, BLOCKQUOTE: 1,
    UL: 1, OL: 1, LI: 1, A: 1, H1: 1, H2: 1, H3: 1, H4: 1, H5: 1, H6: 1, DL: 1, DT: 1, DD: 1, PRE: 1, CODE: 1, FIGURE: 1, FIGCAPTION: 1, ABBR: 1, CITE: 1, DEL: 1, INS: 1, S: 1, Q: 1, TIME: 1, LABEL: 1, BR: 1 };
  /* 2026-10-17（Codex r35e）：由 CSS class 定義的背景圖（.size-chart{background-image:url(...)}）只有算出來的樣式看得到。
     getComputedStyle 不存在或丟例外就當沒有背景（try/catch）。🔴 時間點：splitDescription 在搬任何節點之前先對 src 底下所有元素掃一次、把結果記在元素的 _csBg 屬性上
     （markBackgrounds），hasRenderable 讀這個記錄；搬走之後選擇器脈絡（例如 .cs-p02-fold__src .size-chart）就變了，再算沒有意義。沒記錄過的元素（自己新建的容器）才即時算。 */
  function computedBg(el) {
    try {
      if (!window.getComputedStyle) { return false; }
      var bi = window.getComputedStyle(el).backgroundImage;
      return !!bi && bi !== 'none';
    } catch (e) { return false; }
  }
  /* 2026-10-17（Codex r35f 效能）：只對「候選元素」查 getComputedStyle——候選＝去空白後沒有文字、而且沒有媒體後代（含自己）的元素
     （有字或有媒體的元素本來就算呈現，不需要查；祖先和後代若都是候選就都查，因為背景可能設在任何一層）。其餘元素一律記成 false，之後 hasRenderable 不會再即時查。
     查詢上限 BG_CAP＝200 次；候選超過上限，其餘候選一律標成「有背景」（保守：寧可多留，不刪內容）。回傳 { q: 查詢次數, cap: 是否觸頂 } 供 data-split 記號。 */
  var BG_CAP = 200;
  function markBackgrounds(root) {
    var cands = [];
    function walk(el) {
      var text = false, media = false;
      var kids = el.childNodes;
      for (var i = 0; i < kids.length; i++) {
        var c = kids[i];
        if (c.nodeType === 3) { if ((c.textContent || '').replace(/\s+/g, '') !== '') { text = true; } }
        else if (c.nodeType === 1) { var r = walk(c); if (r.text) { text = true; } if (r.media) { media = true; } }
      }
      var tag = String(el.tagName || '').toUpperCase();
      if (RENDER_MEDIA[tag] || (tag === 'A' && el.hasAttribute('href'))) { media = true; }
      if (!text && !media) { cands.push(el); } else { el._csBg = false; }
      return { text: text, media: media };
    }
    root._csBg = false;   // 容器本身（描述外框 .cs-p02-fold__src）是我們自己的元素，不查
    var rk = root.childNodes;
    for (var k = 0; k < rk.length; k++) { if (rk[k].nodeType === 1) { walk(rk[k]); } }
    var res = { q: 0, cap: 0 };
    for (var j = 0; j < cands.length; j++) {
      if (res.q < BG_CAP) { cands[j]._csBg = computedBg(cands[j]); res.q += 1; }
      else { cands[j]._csBg = true; res.cap = 1; }
    }
    return res;
  }
  function hasRenderable(n) {
    if (!n) { return false; }
    if (n.nodeType === 3) { return (n.textContent || '').replace(/\s+/g, '') !== ''; }   // JS 的 \s 含 &nbsp;（U+00A0）
    if (n.nodeType !== 1) { return false; }   // 註解等
    if (isDupMarked(n)) { return false; }
    var tag = String(n.tagName || '').toUpperCase();
    if (RENDER_MEDIA[tag]) { return true; }
    if (tag === 'A' && n.hasAttribute('href')) { return true; }
    var role = n.getAttribute ? n.getAttribute('role') : null;
    if (role && String(role).toLowerCase() === 'img') { return true; }
    var style = n.getAttribute ? n.getAttribute('style') : null;
    if (style && String(style).toLowerCase().indexOf('background') !== -1) { return true; }
    var bg = n._csBg;
    if (bg === undefined) { bg = computedBg(n); }
    if (bg) { return true; }
    if (tag.indexOf('-') !== -1 || !RENDER_WRAPPERS[tag]) { return true; }
    if (tag === 'BR') { return false; }
    return hasRenderableIn(n);
  }
  function hasRenderableIn(el) {
    if (!el) { return false; }
    var kids = el.childNodes;
    for (var i = 0; i < kids.length; i++) { if (hasRenderable(kids[i])) { return true; } }
    return false;
  }
  function hasContent(el) { return hasRenderableIn(el); }
  function isBlankNode(n) { return !hasRenderable(n); }
  /* 真的什麼都沒有：沒有任何會被呈現的子節點。介紹區、規格列、保養列只有在這個條件下才可以移除 */
  function isTrulyEmpty(el) { return !hasRenderableIn(el); }

  /* 2026-10-17（Codex r35b #1）：小標與列名重複只認「完整小標白名單」，去頭尾空白後全等才算（繁簡各一份）；或整句等於該列的列名。
     「結構特色」「首次使用與安全」「兼容」這類一律不藏。 */
  var DUP_HEADINGS = {
    intro: ['產品介紹', '商品介紹', '產品簡介', '商品簡介', '簡介', '介紹', '產品介紹與選購', '商品介紹與選購', '產品特色', '商品特色', '特色',
      '产品介绍', '商品介绍', '产品简介', '商品简介', '简介', '介绍', '产品介绍与选购', '商品介绍与选购', '产品特色', '商品特色', '特色'],
    spec: ['產品規格', '商品規格', '規格', '產品資料', '商品資料', '規格資料',
      '产品规格', '商品规格', '规格', '产品资料', '商品资料', '规格资料'],
    care: ['使用與保養', '保養', '清潔與保養', '保養方法', '保養與清潔', '使用及保養',
      '使用与保养', '保养', '清洁与保养', '保养方法', '保养与清洁', '使用及保养']
  };
  function isDupHeading(text, kind, label) {
    var t = String(text || '').trim();
    if (!t) { return false; }
    var l = String(label || '').trim();
    if (l && t === l) { return true; }
    var list = DUP_HEADINGS[kind];
    return !!list && list.indexOf(t) !== -1;
  }
  /* 只標「容器的第一個元素子節點、而且是 h5」（等同原本的 :first-child），而且要通過 isDupHeading；標了才會被 CSS .cs-p02-dup-h 藏起來 */
  function markDupHeading(container, kind, row) {
    var first = container && container.firstElementChild;
    var owner = container && container.closest('[data-cs-p02-fold]');
    if (owner && !owner.hasAttribute('data-cs-p02-content-protected')) {
      while (first && first.tagName !== 'H5' && q('h5', first)) {
        // Only descend through a leading wrapper; never hide a later feature heading.
        if (Array.prototype.some.call(first.childNodes, function (n) { return n.nodeType === 3 && (n.textContent || '').trim(); })) { break; }
        first = first.firstElementChild;
      }
    }
    if (!first || first.tagName !== 'H5') { return false; }
    var labelEl = row && (q('.cs-p02-fold__label', row) || q('.cs-p02-intro__title', row));
    var duplicate = isDupHeading(first.textContent, kind, labelEl ? labelEl.textContent : '');
    if (!duplicate && owner && !owner.hasAttribute('data-cs-p02-content-protected')) {
      // Exact generic heading aliases only; keep meaningful feature/safety subheadings.
      var aliases = {
        intro: ['product introduction', 'about this product', 'product overview', '商品紹介', '製品紹介'],
        spec: ['product specifications', 'specifications', '製品仕様', '仕様'],
        care: ['use & cleaning', 'cleaning & care', 'care & cleaning', '使い方とお手入れ', 'お手入れ']
      };
      duplicate = aliases[kind].indexOf(String(first.textContent || '').trim().toLowerCase()) !== -1;
    }
    if (!duplicate) { return false; }
    first.classList.add('cs-p02-dup-h');
    return true;
  }

  function splitDescription(fold) {
    var src = q('[data-cs-p02-desc-src]', fold);
    if (!src || fold.hasAttribute('data-split') || fold.hasAttribute('data-split-miss')) { return; }
    var preserveBaseline = fold.hasAttribute('data-cs-p02-content-protected');
    var specRow = q('[data-row="spec"]', fold);
    var careRow = q('[data-row="care"]', fold);
    var specBody = q('[data-cs-p02-fold-body="spec"]', fold);
    var careBody = q('[data-cs-p02-fold-body="care"]', fold);
    // 2026-10-17（一-13）：商品介紹區（不可收合）。分類為 intro 的 h5 段落搬進它；切不動或沒有內容時整區移除，描述全文留在規格列
    var introRow = q('[data-row="intro"]', fold);
    var introBody = q('[data-cs-p02-intro-body]', fold);
    function dropIntro() { if (introRow) { introRow.remove(); } }
    var bgStat = markBackgrounds(src);   // 一定要在搬任何節點之前（見 computedBg 的說明）
    var h5s = qa('h5', src);
    if (!h5s.length) {
      // 完全沒有 h5（主理 10-17 裁示）：整段描述都是介紹，全部搬進商品介紹區；規格列只剩 facts（也空就照既有邏輯整列移除）。沒有介紹區（舊 HTML）才維持原樣留在規格列
      if (careRow) { careRow.remove(); }
      if (introBody) {
        Array.prototype.slice.call(src.childNodes).forEach(function (x) { introBody.appendChild(x); });
        var wholeHas = !isTrulyEmpty(introBody);
        if (introRow) { if (wholeHas) { introRow.hidden = false; } else { introRow.remove(); } }
        var specHasNoH5 = hasContent(specBody);
        if (specRow && !specHasNoH5) { specRow.remove(); }
        fold.setAttribute('data-split', 'h5=0 spec=0 care=0 mixed-split=0 mixed-kept=0 intro=whole bgq=' + bgStat.q + ' bgcap=' + bgStat.cap + ' rows=' + (wholeHas ? 'intro,' : '') + (specHasNoH5 ? 'spec,' : '') + 'review');
        return;
      }
      fold.setAttribute('data-split-miss', 'no h5');
      dropIntro();
      return;
    }
    // 最近的共同祖先：h5 全在同一層（最常見，直接掛在 src 底下）或都在某個包裝容器裡
    var host = commonAncestor(h5s, src);
    if (h5s.length === 1 && h5s[0].parentNode !== host) { host = h5s[0].parentNode; }
    // 2026-10-17（Codex r35a #5）：h5 不是直接掛在描述最外層（巢狀在包裝容器裡）＝結構異常，不切：移除介紹區與保養列，描述原樣完整留在規格列
    if (host !== src && preserveBaseline) {
      fold.setAttribute('data-split-miss', 'nested host');
      if (careRow) { careRow.remove(); }
      dropIntro();
      return;
    }
    // 2026-10-22（r42 #2）：Lelit 等頁有一個 host 直接子節點（非 h5）把 ≥2 個 h5 全掛在自己底下，原本一律判「nested multiple h5」不切。
    // 遞迴展開 h5 的祖先（主理 10-22 裁示，Anna 的 h5 掛在好幾層版面 div 底下）：只對「含 ≥2 個 h5 的 host 直接子節點 k」做 — k 換成它的 childNodes，
    // 其中仍含 h5 的非 h5 子節點再同樣換成 childNodes，直到每個 h5 都是頂層項目；不含 h5 的節點原樣保留、照文件順序。深度上限 20 層，超過就整個 k 放棄展開（照樣判 unsplittable）。
    // 只含 1 個 h5 的子節點維持原行為（當段落起點），絕不展開。被搬空的原節點留在原位不處理；有展開才在 data-split 尾巴加 flat=<被展開的元素總數，含各層>。
    var kids = [];
    var flatN = 0;
    var flatKs = [];   // 這次被展開的 host 直接子節點；搬完後若被掏空就移除（見下方 flatKs.forEach）
    var FLAT_MAX_DEPTH = 20;
    function flatten(node, depth, out, cnt) {
      if (depth > FLAT_MAX_DEPTH) { return false; }
      cnt.n += 1;
      var cs = node.childNodes;
      for (var ci = 0; ci < cs.length; ci++) {
        var c = cs[ci];
        if (c.nodeType === 1 && c.tagName !== 'H5' && qa('h5', c).length > 0) {
          if (!flatten(c, depth + 1, out, cnt)) { return false; }
        } else { out.push(c); }
      }
      return true;
    }
    // Split nested layout wrappers at H5 boundaries while retaining their attributes,
    // text, links and media. Each clone contains at most one H5; no body text is filtered.
    function sectionPieces(node) {
      if (node.nodeType !== 1 || node.tagName === 'H5' || !q('h5', node)) { return [node]; }
      var pieces = [], shell = node.cloneNode(false);
      shell._csBg = node._csBg;
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        sectionPieces(child).forEach(function (piece) {
          var begins = piece.nodeType === 1 && (piece.tagName === 'H5' || q('h5', piece));
          if (begins && shell.childNodes.length) { pieces.push(shell); shell = node.cloneNode(false); shell.removeAttribute('id'); shell._csBg = node._csBg; }
          shell.appendChild(piece);
        });
      });
      if (shell.childNodes.length) { pieces.push(shell); }
      // Nodes moved to the cloned shells above; remove only the now-empty original wrapper.
      node.remove();
      return pieces;
    }
    if (!preserveBaseline) {
      host = src;
      Array.prototype.slice.call(src.childNodes).forEach(function (node) {
        sectionPieces(node).forEach(function (piece) { kids.push(piece); });
      });
    }
    if (preserveBaseline) {
    Array.prototype.slice.call(host.childNodes).forEach(function (k) {
      if (k.nodeType === 1 && k.tagName !== 'H5' && qa('h5', k).length >= 2) {
        var out = [];
        var cnt = { n: 0 };
        if (flatten(k, 1, out, cnt)) {
          out.forEach(function (c) { kids.push(c); });
          flatN += cnt.n;
          flatKs.push(k);
          return;
        }
      }
      kids.push(k);
    });
    }
    // 每個「段落起點」＝ host 的直接子節點裡，是 h5 或裡面含 h5 的那一個
    var starts = [];
    var unsplittable = false;
    kids.forEach(function (k, i) {
      if (k.nodeType !== 1) { return; }
      var n = k.tagName === 'H5' ? 1 : qa('h5', k).length;
      if (k.tagName === 'H5' || n > 0) {
        if (k.tagName !== 'H5' && n > 1) { unsplittable = true; }
        starts.push({ i: i, node: k, h5: k.tagName === 'H5' ? k : q('h5', k) });
      }
    });
    if (unsplittable || !starts.length) {
      fold.setAttribute('data-split-miss', unsplittable ? 'nested multiple h5' : 'no h5 among host children');
      if (careRow) { careRow.remove(); }
      dropIntro();
      return;
    }
    var moved = { spec: 0, care: 0, mixedSplit: 0, mixedKept: 0, intro: 0, preamble: 0 };
    // 第一個 h5 之前的前言節點（主理 10-17 裁示）也歸商品介紹區，排在最前面
    if (introBody && starts[0].i > 0) {
      kids.slice(0, starts[0].i).forEach(function (x) { introBody.appendChild(x); });
      moved.preamble = starts[0].i;
    }
    var specMoved = document.createElement('div');
    specMoved.setAttribute('data-cs-p02-moved', '');
    starts.forEach(function (st, n) {
      var kind = classifyHeading(st.h5.textContent);
      var end = n + 1 < starts.length ? starts[n + 1].i : kids.length;
      var nodes = kids.slice(st.i, end);
      if (kind === 'intro') {
        // 導言段落（摘要、產品介紹與選購、影片介紹…）搬進商品介紹區；沒有這個區（舊 HTML）就留在原處
        if (introBody) { nodes.forEach(function (x) { introBody.appendChild(x); }); moved.intro += 1; }
        return;
      }
      if (kind === 'mixed') {
        var m = careMarkerIndex(nodes);
        if (m === -1) { kind = 'spec'; moved.mixedKept += 1; }
        else {
          nodes.slice(0, m).forEach(function (x) { specMoved.appendChild(x); });
          nodes.slice(m).forEach(function (x) { careBody.appendChild(x); });
          moved.spec += 1; moved.care += 1; moved.mixedSplit += 1;
          return;
        }
      }
      var into = kind === 'care' ? careBody : specMoved;
      nodes.forEach(function (x) { into.appendChild(x); });
      moved[kind] += 1;
    });
    // 2026-10-22（Codex r42-a）：被展開、搬空後只剩空白與空版面容器（DIV／SPAN／SECTION，無任何文字）的包裝節點 k 從描述根節點移除，否則 :not(:empty) 的 CSS 繼續命中、帶背景的空殼還會讓規格列誤判有內容。只處理被展開的 k。
    flatKs.forEach(function (k) {
      if (k.parentNode !== host || (k.textContent || '').replace(/\s+/g, '') !== '') { return; }
      var onlyShells = Array.prototype.every.call(k.querySelectorAll('*'), function (d) { return d.tagName === 'DIV' || d.tagName === 'SPAN' || d.tagName === 'SECTION'; });
      if (onlyShells) { k.remove(); }
    });
    if (!isTrulyEmpty(specMoved)) { specBody.appendChild(specMoved); }
    // 小標與列名重複才標記（CSS 只藏有標記的）
    var dupN = (markDupHeading(introBody, 'intro', introRow) ? 1 : 0) + (markDupHeading(specMoved, 'spec', specRow) ? 1 : 0) + (markDupHeading(careBody, 'care', careRow) ? 1 : 0);
    // 空的列整列移除（不留分隔線與 padding）
    var careHas = !isTrulyEmpty(careBody);   // 搬進去的節點只要還有任何元素或文字就留列，不因為判斷太窄而讓內容消失
    if (careRow) { if (careHas) { careRow.hidden = false; } else { careRow.remove(); } }
    var introHas = !isTrulyEmpty(introBody);
    if (introRow) { if (introHas) { introRow.hidden = false; } else { introRow.remove(); } }
    var specHas = hasContent(specBody);
    if (specRow && !specHas) { specRow.remove(); }
    fold.setAttribute('data-split', 'h5=' + h5s.length + ' spec=' + moved.spec + ' care=' + moved.care +
      ' mixed-split=' + moved.mixedSplit + ' mixed-kept=' + moved.mixedKept + ' intro=' + moved.intro + ' preamble=' + moved.preamble + ' dup-h=' + dupN + ' bgq=' + bgStat.q + ' bgcap=' + bgStat.cap + ' rows=' + (introHas ? 'intro,' : '') + (specHas ? 'spec,' : '') + 'review' + (careHas ? ',care' : '') + (flatN ? ' flat=' + flatN : ''));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }

    var card = t.closest('[data-cs-p02-o1-card]');
    if (card) {
      if (card.tagName === 'A') { return; } // link 模式：交給瀏覽器
      var o1 = card.closest('[data-cs-p02-o1]');
      if (o1) { selectCategory(o1, card); }
      return;
    }

    var more = t.closest('[data-cs-p02-o1-more]');
    if (more) {
      var root = more.closest('[data-cs-p02-o1]');
      if (root) {
        root.setAttribute('data-expanded', root.getAttribute('data-expanded') === '1' ? '0' : '1');
        sync(root);
      }
      return;
    }

    var cmore = t.closest('[data-cs-p02-codex-more]');
    if (cmore) {
      qa('[data-cs-p02-o1]').forEach(function (r) {
        if (r._csMore === cmore) {
          r.setAttribute('data-codex-expanded', r.getAttribute('data-codex-expanded') === '1' ? '0' : '1');
          sync(r);
        }
      });
      return;
    }

    var link = t.closest('[data-cs-p02-review-link]');
    if (link) {
      // r36：評價區用 CSS order 把本商品 widget 排到最後，跳到 widget 會略過摘要與卡片，所以先跳整個評價 section
      var target = q('[id$="__17125462997f7bb2f5"]') ||
        document.getElementById('judgeme_product_reviews') ||
        q('.jdgm-review-widget, .jdgm-rev-widg, .jdgm-widget');
      if (target && target.scrollIntoView) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  // 主題換款：updateVariantInputs 在 updateURL「之後」對 form 的 input[name=id] 送 change，所以這裡補 view=p02 剛好在主題改完網址之後
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="id"]')) { onIdChange(t); keepView(); later(); return; }
    var vs = t && t.closest ? t.closest('variant-selects') : null;
    var info = vs ? vs.closest('product-info') : null;
    if (info) { beginPending(info); }
  }, true);
  window.addEventListener('popstate', later);
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    [window.PUB_SUB_EVENTS.variantChange, window.PUB_SUB_EVENTS.optionValueSelectionChange].forEach(function (name) {
      if (name) { window.subscribe(name, function () { window.requestAnimationFrame(keepView); return Promise.resolve(); }); }
    });
  }

  // 只看「新增的元素節點」，而且排除 O1 自己與我們自己加的按鈕：我們改自己的字、換自己的卡不該再觸發同步
  function isOurs(node) {
    return !!(node.closest && (node.closest('[data-cs-p02-o1]') || node.closest('[data-cs-p02-codex-more]') || node.closest('[data-cs-p02-sub]') || node.hasAttribute && node.hasAttribute('data-cs-p02-sub') || node.closest('[data-cs-p02-fold]')));
  }

  function start() {
    qa('[data-cs-p02-fold]').forEach(splitDescription);
    syncAll();
    if (window.MutationObserver) {
      new MutationObserver(function (ms) {
        for (var i = 0; i < ms.length; i++) {
          var added = ms[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1 && !isOurs(added[j])) { later(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('load', later);
    if (window.PerformanceObserver) {
      try {
        new window.PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) {
            if (!pending || en.name.indexOf('option_values=') === -1 || !sameSection(en.name, pending)) { return; }
            if (typeof en.responseStatus !== 'number') { return; }
            // 被新請求取消的舊請求也會留一筆 status 0：只看「開始時間不早於最後一次發請求」的那一筆
            if ((en.responseStatus === 0 || en.responseStatus >= 400) && en.startTime >= pending.lastStart - 5) { failPending('fetch-' + en.responseStatus); }
          });
        }).observe({ type: 'resource' });
      } catch (e) { /* 舊瀏覽器：靠逾時計時 */ }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
